import { Box, RadioGroup } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { RadioField } from "@/components";
import { mapExpenseTypeToValuationOrRent } from "@/helpers/playgroundSeriesRequestHelper";
import { ExpenseType } from "@/types/playground";

import { PlaygroundFilterSectionTitle } from "./PlaygroundFilterSectionTitle";

const expenseTypes = Object.values(ExpenseType);

export type ExpenseTypeSectionProps = {
  currentExpenseType?: ExpenseType;
  onCurrentExpenseTypeChange: (expenseType: ExpenseType) => void;
};

export const ExpenseTypeSection = ({
  currentExpenseType: currentExpenseType,
  onCurrentExpenseTypeChange: onCurrentExpenseTypesChange,
}: ExpenseTypeSectionProps): JSX.Element => {
  const { t } = useTranslation("PlaygroundPage");

  const handleExpenseTypeChange = (_event: React.ChangeEvent<HTMLInputElement>, value: string): void => {
    onCurrentExpenseTypesChange(value as ExpenseType);
  };

  return (
    <Box sx={{ p: "13px 20px" }}>
      <PlaygroundFilterSectionTitle title={t("filter.expenseTypeSection.title")} />
      <RadioGroup value={currentExpenseType} onChange={handleExpenseTypeChange}>
        {expenseTypes.map((expenseType, index) => (
          <RadioField
            key={expenseType}
            selected={currentExpenseType == expenseType}
            value={expenseType}
            label={t("filter.expenseTypeSection.options", { context: mapExpenseTypeToValuationOrRent(expenseType) })}
            sx={() => ({
              ...(index < expenseTypes.length - 1 && { mb: 1 }),
            })}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};
